var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"type":"button"},on:{"click":_vm.logout}},[_vm._v("ログアウト")])
}
var staticRenderFns = []

export { render, staticRenderFns }